import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL, trackWhatsAppClick } from "@/lib/site";

export default function StickyCta({ onRequest }) {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#FAF7F2]/95 backdrop-blur-lg border-t border-[#E5D3AD]/60 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] flex gap-3"
    >
      <button
        data-testid="sticky-request-btn"
        onClick={() => onRequest()}
        className="flex-1 bg-[#1B3B2B] text-[#FAF7F2] font-semibold tracking-wide text-[12px] py-3.5 rounded-full shadow-[0_8px_24px_rgb(27,59,43,0.25)]"
      >
        REQUEST YOUR USA CONSULTATION
      </button>
      <a
        data-testid="sticky-whatsapp-btn"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackWhatsAppClick("sticky_bar")}
        className="flex items-center justify-center gap-2 border border-[#1B3B2B]/30 text-[#1B3B2B] font-semibold tracking-wide text-[12px] px-5 py-3.5 rounded-full"
      >
        <MessageCircle className="w-4 h-4" />
        WhatsApp Us
      </a>
    </div>
  );
}
